import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/connection-api.vue
var s = {
	name: "DtIconConnectionApi",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--connection-api"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Connection Api",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M3.709 10.416a.5.5 0 0 1 0-.707L5.23 8.188 4.062 7.02l-1.52 1.52a.5.5 0 1 1-.707-.707l1.521-1.521-.584-.584a.5.5 0 0 1 0-.708l1.562-1.56a2.268 2.268 0 0 1 3.207 0l.271.271 1.21-1.209a.5.5 0 1 1 .707.708l-1.21 1.209.272.271a2.268 2.268 0 0 1 0 3.207L7.229 9.48a.5.5 0 0 1-.708 0l-.583-.584-1.522 1.521a.5.5 0 0 1-.707 0Zm3.125-6.25a1.268 1.268 0 0 0-1.793 0L3.832 5.375l3.043 3.043 1.209-1.209a1.268 1.268 0 0 0 0-1.793l-1.25-1.25Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=connection-api.js.map